import React from "react";

import ProductHotspotInfoBox from "./ProductHotspotInfoBox";
import calculateImagePosition from "../../../utils/calculateImagePosition";

export default ({ api: { hotspots, imageSrc } }) => (
  <div className="container">
    <div className="row">
      {Object.values(hotspots).map((hotspot) => {
        const { imageX, imageY } = calculateImagePosition({ hotspot });
        return (
          <div className="col-12" key={`${imageX}${imageY}`}>
            <ProductHotspotInfoBox
              imageSrc={imageSrc}
              imageX={imageX}
              imageY={imageY}
              selectedIcon={hotspot}
            />
          </div>
        );
      })}
    </div>
  </div>
);
